import React, { useEffect } from 'react';
import { Flex } from '@workday/canvas-kit-react';
import { RESET_AUTHENTICATOR_PATH, TRUSTED_DEVICE_PATH } from '../../../react-router-paths';
import { useHistory } from 'react-router-dom';
import { TOTPVerificationForm } from '../../../shared/totpVerificationForm/TOTPVerificationForm';
import { TertiaryButton } from '@workday/canvas-kit-react/button';
import { autoId } from '@workday/upc-common';
import { ID_RESET_AUTHENTICATOR_BUTTON } from '../../../autoIds';
import { useTranslation } from 'react-i18next';
import { useMfaInitMutation } from '../../../slices/account-api.slice';
import { useVerifyLoginTotpMutation } from '../../../slices/auth-api.slice';
import { LoginLink } from '../../../shared/login-link/login-link';

export function LoginTOTPVerify({ otpContact }) {
    const history = useHistory();
    const { t } = useTranslation('auth');
    const [mfaInit, mfaInitMutation] = useMfaInitMutation();
    const [verifyLoginTotp, verifyLoginTotpMutation] = useVerifyLoginTotpMutation();

    useEffect(() => {
        if (verifyLoginTotpMutation.isSuccess) {
            if (!verifyLoginTotpMutation.data?.isTrusted) {
                history.replace(TRUSTED_DEVICE_PATH);
            } // else sp login is handled in App.tsx
        }
    }, [history, verifyLoginTotpMutation.data, verifyLoginTotpMutation.isSuccess]);

    function onLostAuthenticatorInit() {
        mfaInit(otpContact);
    }

    useEffect(() => {
        if (mfaInitMutation.isSuccess) {
            history.replace(RESET_AUTHENTICATOR_PATH);
        }
    }, [history, mfaInitMutation.isSuccess]);

    function onSubmit(payload) {
        verifyLoginTotp(payload);
    }

    const isLoading = mfaInitMutation.isLoading || verifyLoginTotpMutation.isLoading;

    return (
        <div className='totpVerify'>
            <TOTPVerificationForm mutation={verifyLoginTotpMutation} onSubmit={onSubmit} disabled={isLoading} />
            <Flex flexDirection={'column'} alignItems={'center'}>
                <TertiaryButton
                    type='button'
                    {...autoId(ID_RESET_AUTHENTICATOR_BUTTON)}
                    className='lostAuthenticator__button'
                    size='large'
                    onClick={onLostAuthenticatorInit}>
                    {t('LoginTOTPVerify.resetAuthenticator')}
                </TertiaryButton>
                <LoginLink />
            </Flex>
        </div>
    );
}
